import delay from '../../utils/delay'

import {
  IUserService,
  GetUser,
  GetUsersEmailData,
} from '../../interfaces/services/user'
import { resultSuccess } from '../../interfaces/base'

export const userServiceMock: (DI: any) => IUserService = (DI) => {
  const getUser: GetUser = async () => {
    await delay(1000)

    return resultSuccess({
      id: 11,
      email: 'john@doe.com',
      full_name: 'John Doe',
      groups: ['memoria-internal'],
      restrictedAccess: false,
    })
  }

  const getUsersEmailData: GetUsersEmailData = async () => {
    await delay(1000)

    return resultSuccess({
      agency: {
        name: 'Digital Media',
        logo: 'http://pmdev.pmd5.org/Logo_DM_Exel.png',
        url: 'https://www.piamedia.com/',
        address: {
          street: 'Georg-Glock-Straße 8',
          city: 'Düsseldorf',
          zip: '40474',
        },
        financeData: {
          companyId: 'HRB 68733',
          taxId: 'DE 284907276',
          managingDirectors: ['Hendrik Faasch'],
        },
      },
      agent: {
        title: '',
        firstname: 'John',
        lastname: 'Doe',
        email: 'john.doe@performance-technologies.de',
        phone: '0211/88 231 711',
      },
      hostname: 'http://memoria-advertiser-int.pmd5.org',
    })
  }

  return {
    getUser,
    getUsersEmailData,
  }
}

export default userServiceMock
